module.exports = __webpack_public_path__ + "img/blank.a5003a85.png";